// eslint-disable-next-line import/prefer-default-export
export function getNameInitials(name: string): string {
  if (!name) return "";

  const words = name.trim().split(" ");
  return words.map((word) => word.charAt(0).toUpperCase()).join("");
}

export const capitalizeWords = (str: string): string =>
  str.replace(/\b\w/g, (char) => char.toUpperCase());

export function rupeesDisplayFull(val: number | string, onlyValue = false): string {
  if (val === null || val === undefined || Number.isNaN(Number(val)))
    return onlyValue ? "0.00" : "Rs. 0.00";
  const n = Number(val);

  return onlyValue ? n.toLocaleString() : `Rs. ${n.toLocaleString()}`;
}
